import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { Item, SuccessPopUp } from '../../common/snippets'
import DropDownOA from '../../common/dropDownOA'
import { headerColumnsMavenManagement } from './constants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import TableCellTooltip from '../../common/TableCellTooltip'
import { focusElemnt, isEmpty, navigation1, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { connect } from 'react-redux'
import { getAllBranchName } from '../../../store/branchAndUserMaster/BUMAction'
import { getUserList } from '../../../store/common/common_action'
import { updateAlertError } from '../../../store/common/common_action'
import { getMavenMgmtTblData, updateMavenUsersData } from '../../../store/branchAndUserMaster/BUMAction'
import moment from 'moment'
import EditIcon from '@mui/icons-material/Edit'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { useTheme } from "@mui/material/styles";
import { CheckMarkSvg } from '../../common/svg/checkMark'
import { XMarkSvg } from '../../common/svg/xMark'
import SuccessAndErrorModal from '../../common/SuccessAndErrorModal'
const MavenManagement = (props) => {
    const { data, updateAlertError, getAllBranchName, getUserList, getMavenMgmtTblData, updateMavenUsersData,loginData } = props
    const { branchAndUserMasterReducer, common } = data
    const { userList } = common
    const { MavenUsersTableData } = branchAndUserMasterReducer
    const [mvnBranchName, setMvnBranchName] = useState('') //all option
    const [mvnUserName, setMvnUserName] = useState('')
    const [branchList, setBranchList] = useState([])
    const [userListData, setUserListData] = useState([])
    const [tableData, setTableData] = useState([])
    const [userReset, setUserReset] = useState(false)
    const [editData, setEditData] = useState({})
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [isSuccess, setIsSuccess] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [manageFocus, setManageFocus] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const theme = useTheme()
    useEffect(() => {
        setTimeout(() => {
            focusElemnt('mvnMgmtBranchName')
        }, 0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getTableData = () => {
        if (mvnBranchName === '' || mvnUserName === '') {
            updateAlertError({ show: true, msg: 'Please Select The Filters', success: false, nextId: `mvnMgmtBranchName` })
        } else {
            const object = {
                CompanyId: loginData?.intCompanyID,
                BranchID: mvnBranchName?.id,
                UserID: mvnUserName?.id
            }
            getMavenMgmtTblData(object)
        }
    }
    useEffect(() => {
        if (MavenUsersTableData?.Table?.length > 0) {
            const data = [...MavenUsersTableData?.Table, ...MavenUsersTableData?.Table1]
            let newData = data?.map((val, i) => ({ ...val, userStatus: val.IsActiveMavenUser, deviceAccess: val.Status, modifiedDateTime: moment(val.MavenAccessChangedDate).format('HH:mm, DD-MMM-YY'), editBtn: true, }))
            newData = removeDuplicatesFromArray(newData, 'DeviceID')
            setTableData(newData)
        } else {
            setTableData([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [MavenUsersTableData])
    useEffect(() => {
        if (loginData?.intCompanyID!=='undefined') {
            getBranchListData()
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    useEffect(() => {
        if (loginData?.intCompanyID!=='undefined' && mvnBranchName !== '') {
            getUserListData()
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID, mvnBranchName])

    const getBranchListData = () => {
        const object = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: "",
            strBranchCode: "",
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1
        }
        getAllBranchName(object,true,24*60*60*1000)?.then((res) => {
            if (res?.status === 'Success') {
                if (res?.Data?.Table?.length < 0) {
                    updateAlertError({ show: true, msg: 'No Data For Branch List', success: false, nextId: `maBranchName` })
                } else {
                    let branches = res?.Data?.Table?.map(obj => ({ name: obj.BranchName, id: obj.BranchID, city: obj.CityName }))
                    branches.sort((a, b) => {
                        return a.name.localeCompare(b.name);
                    });
                    setBranchList([{ name: 'All', id: 0 }, ...branches])
                    let filteredBranch = branches.filter(branch => branch.id === loginData?.intBranchID);
                    filteredBranch.length > 0 ? setMvnBranchName(filteredBranch[0]) : setMvnBranchName("")
                }
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const getUserListData = () => {
        const object = {
            intUserID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: mvnBranchName?.id,
            strUserName: "",
            strLoginID: "",
            strPassword: "",
            strContactNo: "",
            intRoleID: 0,
            intIsActive: 1
        }
        getUserList(object,true,24*60*60*1000)
    }

    useEffect(() => {
        if (userList?.length > 0) {
            var users = []
            userList.map((obj) => (
                users.push({
                    id: obj.UserID,
                    name: obj.UserName,
                })
            ))
            users = removeDuplicatesFromArray(users, `id`)
            // setUserListData(users)
            setUserListData([{ name: "All Users", id: 0 }, ...users])
            let filteredUser = users.filter(user => user.id === loginData?.intUserID);
            filteredUser.length > 0 ? setMvnUserName(filteredUser[0]) : setMvnUserName("")
        } else {
            setUserListData([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userList])
    useEffect(() => {
        if (loginData?.intCompanyID!=='undefined') {
            const object = {
                CompanyId: loginData?.intCompanyID,
                BranchID: loginData?.intBranchID,
                UserID: loginData?.intUserID
            }
            getMavenMgmtTblData(object)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    useEffect(() => {
        setfilteredData(tableData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData])
    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return headerColumnsMavenManagement.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues])
    const handleSave = () => {
        // userStatus:val.IsActiveMavenUser, deviceAccess:val.Status
        let object = {
            UserID: editData.UserID,
            ModifingUserName: loginData?.strUserName,
            IsActive: editData?.userStatus === 'YES' ? 1 : 0,
            EnableHardware: editData?.deviceAccess === 'YES' ? 1 : 0,
            selectedIMEIID: editData?.DeviceID,
            Appid: editData?.appID,
        }
        updateMavenUsersData(object)?.then((res) => {
            if (res?.status === 'Success') {
                setIsSuccess(true)
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const handleHideEditBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            for (let i = 0; i < newVal?.length; i++) {
                if (i === index) {
                    newVal[i].editBtn = !newVal[i].editBtn
                } else {
                    newVal[i].editBtn = true
                }
            }
            setfilteredData(newVal)
            newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
        }
    }
    const handleCrossBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].userStatus = filteredData[index].IsActiveMavenUser
            newVal[index].deviceAccess = filteredData[index].Status
            newVal[index].editBtn = !newVal[index].editBtn
            setfilteredData(newVal)
            setManageFocus(false)
            setTimeout(() => {
                focusElemnt(`editBtn-${index + 1}`)
            }, 0)
        }
    }
    const handleRowChkChange = (e, index, key) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            if (key === 'userStatus') {
                newVal[index].userStatus = e.target.checked ? 'YES' : 'NO'
                focusElemnt(`s-chkbox-${index}`)

            } else if (key === 'deviceAccess') {
                newVal[index].deviceAccess = e.target.checked ? 'YES' : 'NO'
                // setManageFocus(false)
                setTimeout(() => {
                    focusElemnt(`da-checkbox-${index}`)
                }, 0)
            }
            setfilteredData(newVal)
        }

    }
    const ShowMavenManagementConfirmation = () => {
        const data = {
            successMessage: 'Do you want to update the Maven Management Status?',
            otherMessage: '',
            buttonId1: '',
            buttonId2: '',
            headTxt: 'Mac Management',
            yesAction: () => { handleSave(); setShowConfirmation(false) },
            noAction: () => setShowConfirmation(false)
        }
        return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
    }
    const InsideRowContent = ({ item, index }) => {
        const width = window.innerWidth - 40
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ height: '36px', textAlign: 'right', fontSize: '12px', color: '#444444', maxWidth: '2.24%' }}>{index + 1}</TableCell>
                <TableCellTooltip maxWidth={`${Math.ceil((width * 9.99) / 100)}px`} title={item.UserName} data={item.UserName} />
                <TableCell style={{ textAlign: 'left', fontSize: '12px', color: '#444444', maxWidth: '5.99%' }}>{item.BranchCode}</TableCell>
                <TableCellTooltip maxWidth={`${Math.ceil((width * 12.2) / 100)}px`} title={item.BranchName} data={item.BranchName} />
                {/* <TableCellTooltip maxWidth={`${Math.ceil((width *11.24) / 100)}px`} title={item.CompanyName} data={item.CompanyName} /> */}
                <TableCellTooltip maxWidth={`${Math.ceil((width * 20.49) / 100)}px`} title={item.DeviceID} data={item.DeviceID} />
                <TableCellTooltip maxWidth={`${Math.ceil((width * 10.49) / 100)}px`} title={item.DeviceIssuerName} data={item.DeviceIssuerName} />
                <TableCellTooltip maxWidth={`${Math.ceil((width * 9.9) / 100)}px`} title={item.modifiedDateTime} data={item.modifiedDateTime} />
                <TableCellTooltip maxWidth={`${Math.ceil((width * 9.14) / 100)}px`} title={item.MavenAccessChangedBy} data={item.MavenAccessChangedBy} />
                <TableCell style={{ textAlign: 'right', fontSize: '12px', color: '#444444', maxWidth: '7.11%' }}>{item.UserMavenRent}</TableCell>
                {item.editBtn ? <TableCell style={{ textAlign: 'center', fontSize: '12px', color: '#444444', maxWidth: '4.48%' }}>
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                        {item.userStatus === 'YES' ? <CheckMarkSvg /> : <XMarkSvg />}
                    </span></TableCell> :
                    <TableCell style={{ textAlign: 'center', fontSize: '12px', color: '#444444', maxWidth: '4.48%' }}>
                        <Checkbox
                            id={`s-checkbox-${index}`}
                            autoFocus={manageFocus}
                            checked={item.userStatus === 'YES'}
                            sx={{ padding: '0', borderRadius: '0' }}
                            onChange={(e) => handleRowChkChange(e, index, 'userStatus')}
                            onKeyDown={(e) => navigation1(e, `da-checkbox-${index}`, `xMark-${index}`)}
                        // onKeyDown={(e) => checkBoxNavigation(e, `da-checkbox-${index}`, `xMark-${index}`, index)}
                        />
                    </TableCell>}
                {item.editBtn ? <TableCell style={{ textAlign: 'center', fontSize: '12px', color: '#444444', maxWidth: '4.48%' }}>
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                        {item.deviceAccess === 'YES' ? <CheckMarkSvg /> : <XMarkSvg />}
                    </span></TableCell> :
                    <TableCell style={{ textAlign: 'center', fontSize: '12px', color: '#444444', maxWidth: '4.48%' }}>
                        <Checkbox
                            id={`da-checkbox-${index}`}
                            checked={item.deviceAccess === 'YES'}
                            sx={{ padding: '0', borderRadius: '0' }}
                            onChange={(e) => handleRowChkChange(e, index, 'deviceAccess')}
                            onKeyDown={(e) => navigation1(e, `checkMark-${index}`, `s-checkbox-${index}`)}
                        />
                    </TableCell>}
                <TableCell key={`edit-cell-${index}`} style={{ textAlign: 'center', fontSize: '12px', color: '#444444', maxWidth: '6.49%' }}>
                    {item.editBtn ? (
                        <span
                            id={`editBtn-${index}`}
                            tabIndex={0}
                            style={{
                                display: 'flex',
                                width: '52px',
                                color: theme.palette.primary.main,
                                fontSize: '13px',
                                fontWeight: 'bold',
                                padding: '2px 2px',
                                justifyContent: 'center',
                                textAlign: 'center',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                cursor:"pointer"
                            }}
                            onClick={() => { handleHideEditBtn(index) }}
                            onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'mvnMgmtBranchName' : `editBtn-${index + 1}`, index === 0 ? "mvnLoadBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
                        >
                            <EditIcon sx={{ marginRight: '3px',cursor:"pointer" }} />
                            Edit
                        </span>
                    ) :
                        <div key={`check-cross-${index}`} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'center', gap: '1px' }}>
                            <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                                onClick={() => { setEditData(item); setShowConfirmation(true) }}
                                style={{ margin: '0px 0px', width: '25px', padding: '1px 1px', height: '26px', marginTop: '-4px', display: 'flex', justifyContent: 'center' }}
                                onKeyDown={(e) => navigation3(e, `xMark-${index}`, `da-checkbox-${index}`, () => { setEditData(item); setShowConfirmation(true) })}
                            >
                                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50' }} fontSize='large' />
                            </span>
                            <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                                onClick={() => handleCrossBtn(index)}
                                style={{ margin: '0px 0px', width: '25px', padding: '0px 1px', height: '26px', marginTop: '-4px', display: 'flex', justifyContent: 'center' }}
                                onKeyDown={(e) => navigation3(e, `s-checkbox-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
                            >
                                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red' }} fontSize="large" />
                            </span>
                        </div>}
                </TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={sx.reportFlex} className="reportButton">
                <Item sx={sx.itemsx}>
                    <DropDownOA id='mvnMgmtBranchName'
                        label={'Branch Name'}
                        minWidth="250px"
                        defaultvalue={mvnBranchName?.name || ''}
                        value={mvnBranchName?.name || ''}
                        data={branchList || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setMvnBranchName(value)
                            setUserReset(false);
                            setTimeout(() => {
                                setUserReset(true)
                            }, 100);
                        }}
                        prevId='mvnLoadBtn'
                        nextId='mvnUserName' />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id='mvnUserName'
                        label={'Select User'}
                        minWidth="250px"
                        defaultvalue={mvnUserName?.name || ''}
                        value={mvnUserName?.name || ''}
                        data={userListData || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setMvnUserName(value)
                        }}
                        prevId='mvnMgmtBranchName'
                        nextId='mvnLoadBtn'
                        resetFlag={userReset}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='mvnLoadBtn' variant="contained" style={{ ...sx.fullHeight, ...sx.novp }}
                        className="btn btn-primary"
                        onClick={() => { getTableData() }}
                        onKeyDown={(e) => { navigation1(e, filteredData?.length > 0 ? `editBtn-0` : 'mvnMgmtBranchName', 'mvnUserName') }}
                    >
                        LOAD
                    </Button>
                </Item>
            </Box>
            <Box sx={{ margin: '15px 20px 0px 20px' }}>
                <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '70vh', marginBottom: '5px' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px',
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: '2', whiteSpace: 'pre' }}>
                            <TableRow>
                                {headerColumnsMavenManagement.map((col, index) => (
                                    <TableCell
                                        key={`TH-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            height: '36px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444',
                                            verticalAlign: 'top'
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {headerColumnsMavenManagement.map((col, index) =>
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`index-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder="Contains"
                                                    onChange={(e) => handleChangeContain(e, col.field)}
                                                    onKeyDown={(e) => navigation1(e, index === 8 ? `index-1` : `index-${index + 1}`, index === 1 ? `index-8` : `index-${index - 1}`)}
                                                />
                                                <FilterAltIcon />
                                            </div>
                                        </TableCell>
                                    ) : (
                                        <TableCell key={`mvn-empty-cell-${index}`}></TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        {filteredData?.length <= 0 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={14}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>No results found. Please refine your search parameters and search again.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : filteredData.length > 0 ? (
                            <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                                {filteredData?.map((item, index) => (
                                    <InsideRowContent item={item} index={index} key={index} />
                                ))}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                </TableContainer>
            </Box>
            {showConfirmation && <ShowMavenManagementConfirmation />}
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); getTableData();focusElemnt('mvnMgmtBranchName')}} open={isSuccess} title={'Maven Management\nStatus and Access Updated'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getAllBranchName, getUserList, getMavenMgmtTblData, updateMavenUsersData }
export default connect(mapStateToProps, mapDispatchToProps)(MavenManagement)

